module.exports = __webpack_public_path__ + "img/logo.dcc70d3b.png";